// Oberserver and oberserver settings
const containers = document.querySelectorAll(".counting-numbers");
const observerOptions = {
  threshold: 1,
  rootMargin: "0px 0px 0px 0px",
};
const containerObserver = new IntersectionObserver(
  (entries, containerObserver) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      } else {
        // Add animation to each number in the container and remove the observer
        entry.target
          .querySelectorAll(".counting-numbers__item")
          .forEach((number) =>
            animateCountUp(
              number.querySelector(".counting-numbers__item__value")
            )
          );
        containerObserver.unobserve(entry.target);
      }
    });
  },
  observerOptions
);
containers.forEach((image) => {
  containerObserver.observe(image);
});

// Animation settings
const animationDuration = 2000;
const frameDuration = 1000 / 60;
const totalFrames = Math.round(animationDuration / frameDuration);
const easeOutQuad = (t) => t * (2 - t);

// The animation function, which takes an Element
const animateCountUp = (elm) => {
  let frame = 0;
  const countTo = parseInt(elm.innerHTML, 10);
  // Start the animation running 60 times per second
  const counter = setInterval(() => {
    frame++;
    // Calculate our progress as a value between 0 and 1
    // Pass that value to our easing function to get our
    // progress on a curve
    const progress = easeOutQuad(frame / totalFrames);
    // Use the progress value to calculate the current count
    const currentCount = Math.round(countTo * progress);

    // If the current count has changed, update the element
    // and format the value as local string for Germany
    if (parseInt(elm.innerHTML, 10) !== currentCount) {
      elm.innerHTML = currentCount.toLocaleString("de");
    }

    // If we’ve reached our last frame, stop the animation
    if (frame === totalFrames) {
      clearInterval(counter);
    }
  }, frameDuration);
};

// const runAnimations = () => {
// 	const countupEls = document.querySelectorAll( '.countup' );
// 	countupEls.forEach( animateCountUp );
// };
